module.exports = __webpack_public_path__ + "img/arrow-right.6c2acddc.svg";